<template>
  <div class="row flex-grow-1 h-0 no-gutters">
    <div class="d-flex col-4 flex-column gmb-control-column">
      <GmbDataEditionIndividuals
          :individualIds="activatedIndividualIds"
          :individuals="individuals"
          @activated-individuals-changed="onActivatedIndividualsChanged"
      />
    </div>

    <div class="d-flex col-4 pl-3 flex-column gmb-control-column">
      <GmbDataEditionSelectedIndividuals
          :currentClientPk="currentClientPk"
          :currentProjectPk="currentProjectPk"
          :individuals="activatedIndividuals"
          :userAccount="userAccount"
      />
    </div>

    <div class="d-flex col pl-3 flex-column">
      <GmbDataEditionEditForm
          :filterTree="filterTree"
          :individuals="activatedIndividuals"
          title="Détails"
          @individuals-edited="(value) => $emit('individuals-edited', value)"
      >
        <template #picto>
          <FdText colorTheme4 fa><i class="fas fa-clipboard-list"/></FdText>
        </template>
      </GmbDataEditionEditForm>
    </div>
  </div>
</template>

<script>
import FdText from "@/flexdesign/Text";

import GmbDataEditionEditForm from "@/views/Observatory/DataEdition/DataEditionEditForm";
import GmbDataEditionIndividuals from "@/views/Observatory/DataEdition/DataEditionIndividuals";
import GmbDataEditionSelectedIndividuals from "@/views/Observatory/DataEdition/DataEditionSelectedIndividuals";

export default {
  name: "GmbDataEdition",

  components: {
    FdText,
    GmbDataEditionEditForm,
    GmbDataEditionIndividuals,
    GmbDataEditionSelectedIndividuals,
  },

  props: {
    currentClientPk: Number,
    currentProjectPk: Number,
    filterTree: Object,
    individuals: Array,
    userAccount: Object,
  },

  data() {
    return {
      activatedIndividualIds: [],  // FIXME replace by initiallyActivatedIndividualIds prop!
    };
  },

  computed: {
    activatedIndividuals() {
      if (!this.individuals) return [];

      let individualIds = this.activatedIndividualIds.map((individualId) =>
          parseInt(individualId, 10)
      );

      return this.individuals.filter((individual) =>
          individualIds.includes(individual.pk)
      );
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    onActivatedIndividualsChanged(newActivatedIndividualIds) {
      this.activatedIndividualIds = newActivatedIndividualIds;
    },

    // DO NOT DELETE: Async call from another component
    switchToIndividuals(individualIds) {
      this.activatedIndividualIds = individualIds.map(individualId => individualId.toString()); // Reset existing selection
    },
  },
};
</script>

<style lang="scss"></style>
